import React, { useState } from 'react';
import './ReferralModal.css';
import { BASE_URL } from '../config';

const ReferralModal = ({ onClose, referralCode }) => {
  const [copied, setCopied] = useState({ code: false, link: false, message: false });

  const inviteLink = `${BASE_URL}/login.html?form=signup&ref_code=${referralCode || ''}`;
  const inviteMessage = `Discover RealtySeek.ai – your one-stop site for property!

Whether you're selling, buying, or investing, our platform makes it easy to find what you need.

Sign up with my referral code: ${referralCode}
or click here: ${inviteLink}

Start exploring property opportunities today!`;

  const handleCopy = (type) => {
    const textToCopy =
      type === 'code' ? referralCode :
      type === 'link' ? inviteLink :
      inviteMessage;

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied((prev) => ({ ...prev, [type]: true }));

      // Trigger GTM Events
      if (typeof gtag === 'function') {
        const eventName =
          type === 'code' ? 'copy_referral_code' :
          type === 'link' ? 'copy_referral_link' :
          'copy_referral_message';

        gtag('event', eventName, {
          event_category: 'Referral',
          event_label: referralCode || 'unknown',
        });
      }

      setTimeout(() => {
        setCopied((prev) => ({ ...prev, [type]: false }));
      }, 1500);
    });
  };

  return (
    <div className="referral-modal-overlay">
      <div className="referral-modal">
        {(copied.code || copied.link || copied.message) && (
          <div className="referral-toast">Copied!</div>
        )}

        <h1 className="referral-title">Welcome to RealtySeek.ai Referral Program</h1>
        <p className="referral-subtext">
          Great opportunity to make money by just referring potential property buyers, sellers, or investors!
        </p>

        <h2>Your Referral Code</h2>
        <div className="referral-row">
          <input type="text" readOnly value={referralCode || 'N/A'} aria-label="Referral Code" />
          <button onClick={() => handleCopy('code')}>Copy Code</button>
        </div>

        <h3>Invite Link</h3>
        <div className="referral-row">
          <input type="text" readOnly value={inviteLink} aria-label="Invite Link" />
          <button onClick={() => handleCopy('link')}>Copy Link</button>
        </div>

        <h3>Invite Message</h3>
        <div className="referral-row">
          <input type="text" readOnly value={inviteMessage} aria-label="Invite Message" />
          <button onClick={() => handleCopy('message')}>Copy Message</button>
        </div>

        <div className="referral-close-btn-wrapper">
          <button className="close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ReferralModal;
